export default {
  setState: 'Nastaviť stav zariadenia',
  stop: 'Zastaviť: {eventType}',
  start: 'Spustiť: {eventType}',
};
